import "core-js/modules/es6.string.small";
import styled from 'styled-components';
import { FontWeights, Colors } from '../../../consts';
import { ButtonCSSReset } from './ButtonCSSReset';
import { sansSerif } from '../../../helpers';
export var buttonBoxShadow = function buttonBoxShadow(color) {
  return "inset 0 0 0 1px ".concat(color);
};
export var ButtonBaseSkin = styled(ButtonCSSReset).withConfig({
  displayName: "ButtonBaseSkin",
  componentId: "sc-16scoq7-0"
})(["width:", ";padding:12px ", "px;&:hover:not(:disabled){color:", ";}", ";font-size:", "px;line-height:", "px;font-weight:", ";&& > span{", ";font-size:", "px;line-height:", "px;font-weight:", ";}"], function (_ref) {
  var block = _ref.block;
  return block ? '100%' : 'auto';
}, function (props) {
  return props.small ? 16 : 24;
}, Colors.WHITE, sansSerif, function (props) {
  return props.small ? 14 : 16;
}, function (props) {
  return props.small ? 16 : 24;
}, FontWeights.MEDIUM, sansSerif, function (props) {
  return props.small ? 14 : 16;
}, function (props) {
  return props.small ? 16 : 24;
}, FontWeights.MEDIUM);